import { ElMessage } from 'element-plus'
import { isString } from 'lodash-es'

const messageTypes = ['success', 'info', 'warning', 'error'] as const

export type messageType = (typeof messageTypes)[number]

interface MessageOptions {
  message?: string
  type?: messageType
  duration?: number
  showClose?: boolean
}

export type MessageParams = MessageOptions | MessageOptions['message']

type MessageOptionsWithType = Omit<MessageOptions, 'type'>

export type MessageParamsWithType = MessageOptionsWithType | MessageOptions['message']

export interface MessageHandler {
  close: () => void
}

type MessageFn = {
  (options?: MessageParams): MessageHandler
  closeAll(type?: messageType): void
}

type MessageTypedFn = (options?: MessageParamsWithType) => MessageHandler

interface Message extends MessageFn {
  success: MessageTypedFn
  warning: MessageTypedFn
  info: MessageTypedFn
  error: MessageTypedFn
}

const message: MessageFn & Partial<Message> = (options) => {
  return ElMessage(normalizeOptions(options))
}

const normalizeOptions = (params?: MessageParams) => {
  const options = !params || isString(params) ? { message: params } : params
  return {
    showClose: true,
    ...options,
    plain: true,
  }
}

messageTypes.forEach((type) => {
  message[type] = (options) => ElMessage[type](normalizeOptions(options))
})

message.closeAll = ElMessage.closeAll

// TODO 全局显示时间
export const OMessage = message as Message
